var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-wrapper"},[_c('div',{staticClass:"icon-center"},[_c('h2',{staticClass:"overlay-text"},[_vm._v("\" Cette section est actuellement en développement! \"")])])])
}]

export { render, staticRenderFns }